// ===== One-click trading panel (top-left of chart): SELL | lot | BUY, collapsible SL/TP row =====
import { useState } from "react";
import { useStore, chartOf, openPosition, log } from "./store";

// Splits price into small/big/superscript parts like terminal quote boxes
export const PriceDigits = ({ price, digits }) => {
  const s = price.toFixed(digits);
  const frac = digits === 3 || digits === 5;
  const sup = frac ? s.slice(-1) : "";
  const body = frac ? s.slice(0, -1) : s;
  return (
    <span className="oc-price">
      <span className="oc-small">{body.slice(0, -2)}</span>
      <span className="oc-big">{body.slice(-2)}</span>
      <sup className="oc-sup">{sup}</sup>
    </span>
  );
};

export default function OneClick({ chartId }) {
  const st = useStore();
  const c = chartOf(chartId);
  const [lot, setLot] = useState("0.10");
  const [sl, setSl] = useState("");
  const [tp, setTp] = useState("");
  const [open, setOpen] = useState(true);
  const [ext, setExt] = useState(false);
  if (!c.oneClick) return null;
  const s = st.symbols[c.symbol];
  const step = (d) => setLot(Math.max(0.01, +(+lot + d).toFixed(2)).toFixed(2));
  const trade = (type) => {
    if (!(+lot > 0)) return log("invalid volume", "Trades");
    openPosition(c.symbol, type, +lot, sl, tp, "one click");
  };
  return (
    <div className="oc-panel" data-testid="one-click-panel" onMouseDown={(e) => e.stopPropagation()}>
      <button className="oc-toggle" data-testid="one-click-toggle" onClick={() => setOpen(!open)} title="Show/hide one click trading panel">{open ? "◂" : "▸"}</button>
      {open && (
        <div className="oc-body">
          <div className="oc-row">
            <button className="oc-btn oc-sell" data-testid="one-click-sell" onClick={() => trade("sell")}>
              <span className="oc-label">SELL</span>
              <PriceDigits price={s.bid} digits={s.digits} />
            </button>
            <div className="oc-lot">
              <input data-testid="one-click-lot" value={lot} onChange={(e) => setLot(e.target.value)} onBlur={() => setLot((+lot || 0.01).toFixed(2))} />
              <div className="oc-spin">
                <button data-testid="one-click-lot-up" onClick={() => step(0.01)}>▲</button>
                <button data-testid="one-click-lot-down" onClick={() => step(-0.01)}>▼</button>
              </div>
            </div>
            <button className="oc-btn oc-buy" data-testid="one-click-buy" onClick={() => trade("buy")}>
              <span className="oc-label">BUY</span>
              <PriceDigits price={s.ask} digits={s.digits} />
            </button>
          </div>
          <div className="oc-ext-toggle" data-testid="one-click-sltp-toggle" onClick={() => setExt(!ext)}>{ext ? "▴" : "▾"} S/L, T/P</div>
          {ext && (
            <div className="oc-sltp">
              <label>S/L <input data-testid="one-click-sl" value={sl} placeholder="0.00" onChange={(e) => setSl(e.target.value)} /></label>
              <label>T/P <input data-testid="one-click-tp" value={tp} placeholder="0.00" onChange={(e) => setTp(e.target.value)} /></label>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
